<div class="app-component">
    <router-outlet></router-outlet>
</div>